var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2035 2.23633C26.2895 2.23633 32.8446 8.79135 32.8446 16.8774C32.8446 24.9634 26.2895 31.5184 18.2035 31.5184C10.1175 31.5184 3.5625 24.9634 3.5625 16.8774C3.5625 8.79135 10.1175 2.23633 18.2035 2.23633Z",
    fill: "url(#paint0_linear_5141_22215)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1062 31.3937V20.0847H23.2944L23.717 16.1044H20.1062L20.1116 14.1121C20.1116 13.074 20.2102 12.518 21.7013 12.518H23.6947V8.53711H20.5057C16.6753 8.53711 15.3272 10.4679 15.3272 13.7152V16.1047H12.9395V20.0853H15.3272V31.2333C16.2575 31.4186 17.2192 31.5166 18.2038 31.5166C18.84 31.5166 19.4754 31.4755 20.1062 31.3937Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5141_22215",
    x1: 18.2035,
    y1: 1.96955,
    x2: 18.2035,
    y2: 32.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c41fc56f2d4aa27cc6fd3071e5608bdd.svg";
export { ForwardRef as ReactComponent };